import React from 'react';

// Curva cumulativa do valor sacado (em quote) ao longo do tempo — a leitura de "quanto de lucro já
// foi colhido/realizado". Recebe a série diária do /summary ([{day, quote}]) e acumula. SVG puro,
// no mesmo estilo do EquityCurve da Performance (sem dependência de lib de gráfico).
const W = 800, H = 160, PAD = { top: 16, right: 16, bottom: 24, left: 56 };

function fmt(v) {
    if (Math.abs(v) >= 1000) return (v / 1000).toFixed(1) + 'k';
    return v.toFixed(0);
}

function fmtDay(day) {
    const d = new Date(day + 'T00:00:00');
    return `${d.getDate()}/${d.getMonth() + 1}`;
}

function WithdrawProfitChart({ series, quoteSymbol = 'USDT' }) {
    if (!series || series.length < 1) {
        return (
            <div className='card card-body border-0 shadow mb-4 text-center text-muted py-5'>
                Nenhum saque realizado ainda — o lucro colhido aparecerá aqui conforme os saques acontecem.
            </div>
        );
    }

    // Acumula o valor sacado por dia.
    let acc = 0;
    const data = series.map(p => { acc += (p.quote || 0); return { day: p.day, value: Math.round(acc * 100) / 100 }; });

    const total = data[data.length - 1].value;

    // Caso de um único ponto: desenha um marcador só.
    if (data.length === 1) {
        return (
            <div className='card card-body border-0 shadow mb-4'>
                <div className='d-flex justify-content-between align-items-center mb-2'>
                    <h6 className='mb-0'>Lucro colhido (acumulado)</h6>
                    <span className='badge py-1 bg-success'>{total.toFixed(2)} {quoteSymbol}</span>
                </div>
                <p className='text-muted small mb-0'>Primeiro saque em {fmtDay(data[0].day)}: {total.toFixed(2)} {quoteSymbol}.</p>
            </div>
        );
    }

    const maxV = Math.max(...data.map(d => d.value), 0);
    const range = maxV || 1;
    const innerW = W - PAD.left - PAD.right;
    const innerH = H - PAD.top - PAD.bottom;

    function xOf(i) { return PAD.left + (i / (data.length - 1)) * innerW; }
    function yOf(v) { return PAD.top + innerH - (v / range) * innerH; }

    const points = data.map((d, i) => `${xOf(i)},${yOf(d.value)}`).join(' ');
    const color = '#1aae6f';
    const baseY = yOf(0);
    const areaPoints = `${xOf(0)},${baseY} ${points} ${xOf(data.length - 1)},${baseY}`;

    const tickIdxs = [0, Math.floor(data.length * 0.5), data.length - 1];
    const yTicks = [0, maxV / 2, maxV].map(v => Math.round(v * 100) / 100);

    return (
        <div className='card card-body border-0 shadow mb-4'>
            <div className='d-flex justify-content-between align-items-center mb-2'>
                <h6 className='mb-0'>Lucro colhido (acumulado)</h6>
                <span className='badge py-1 bg-success'>{total.toFixed(2)} {quoteSymbol}</span>
            </div>
            <svg viewBox={`0 0 ${W} ${H}`} width='100%' style={{ overflow: 'visible' }}>
                <polygon points={areaPoints} fill={color} fillOpacity='0.12' />
                <polyline points={points} fill='none' stroke={color} strokeWidth='2' strokeLinejoin='round' />
                {data.map((d, i) => (
                    <circle key={d.day} cx={xOf(i)} cy={yOf(d.value)} r='3' fill={color} fillOpacity='0.6' stroke='white' strokeWidth='1'>
                        <title>{fmtDay(d.day)}: {d.value.toFixed(2)} {quoteSymbol} (acumulado)</title>
                    </circle>
                ))}
                {yTicks.map((v, i) => (
                    <text key={i} x={PAD.left - 4} y={yOf(v) + 4} textAnchor='end' fontSize='10' fill='#6c757d'>{fmt(v)}</text>
                ))}
                {tickIdxs.filter(i => i < data.length).map(i => (
                    <text key={i} x={xOf(i)} y={H - 4} textAnchor='middle' fontSize='10' fill='#6c757d'>{fmtDay(data[i].day)}</text>
                ))}
            </svg>
        </div>
    );
}

export default WithdrawProfitChart;
